
import Vue from "vue";
import { mapState } from "vuex";
import store from "@/store";
import { APPLICATION } from "@/store/applications";
import { ReferenceDataType } from "@/store/referenceData/types";
import { getReferenceDataDescription } from "@/helpers/referenceData";

export default Vue.extend({
  methods: {},
  data() {
    return {};
  },
  computed: {
    collectionManager() {
      const promoCollectionManagerType =
        store.state.promoOffer.promoCode &&
        store.state.promoOffer.promoCode.collectionManager;

      const standardCollectionManagerType =
        store.state.standardOffer.offer &&
        store.state.standardOffer.offer.collectionManager;

      const collectionManagerType =
        promoCollectionManagerType || standardCollectionManagerType;

      return getReferenceDataDescription(
        collectionManagerType,
        ReferenceDataType.CollectionManager
      );
    },
    ...mapState({
      bankAccountNumber: () =>
        store.state.application.applicationData &&
        store.state.application.applicationData.finalDetails &&
        store.state.application.applicationData.finalDetails.bankAccountNumber,
      invoiceEmail: () =>
        store.state.application.applicationData &&
        store.state.application.applicationData.finalDetails &&
        store.state.application.applicationData.finalDetails.invoiceEmail,
      NZBNID: () =>
        store.state.application.applicationData &&
        store.state.application.applicationData.businessDetails &&
        store.state.application.applicationData.businessDetails.business &&
        store.state.application.applicationData.businessDetails.business.nzbn,
      NZBNEntityType: () =>
        store.state.application.applicationData &&
        store.state.application.applicationData.businessDetails &&
        store.state.application.applicationData.businessDetails.business &&
        store.state.application.applicationData.businessDetails.business
          .entityTypeCode,
      NZBNRegisterUniqueNumber: () =>
        store.state.application.applicationData &&
        store.state.application.applicationData.businessDetails &&
        store.state.application.applicationData.businessDetails.business &&
        store.state.application.applicationData.businessDetails.business
          .sourceRegisterUniqueIdentifier,
      businessType: () =>
        store.state.application.applicationData &&
        store.state.application.applicationData.businessDetails &&
        store.state.application.applicationData.businessDetails.businessType,
    })
  },
  validations: {}
});
